import React from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from '../ui/carousel';
import { Badge } from '../ui/badge';

const PhotosCarousel = ({ images, title }) => {
  if (!images || images.length === 0) {
    return null;
  }

  // Si une seule image, pas besoin de carousel
  if (images.length === 1) {
    const image = images[0];
    return (
      <div className="relative rounded-xl overflow-hidden shadow-lg">
        <img 
          src={image.src} 
          alt={image.alt}
          className="w-full h-[400px] md:h-[500px] object-cover"
          loading="lazy"
          width={image.width || 1200}
          height={image.height || 800}
        />
        <div className="absolute top-4 right-4">
          <Badge variant="secondary" className="bg-black/60 text-white border-0">
            1/1
          </Badge>
        </div>
      </div>
    );
  }

  return (
    <div className="relative">
      <Carousel className="w-full">
        <CarouselContent>
          {images.map((image, index) => (
            <CarouselItem key={index}>
              <div className="relative rounded-xl overflow-hidden shadow-lg">
                <img 
                  src={image.src} 
                  alt={image.alt}
                  className="w-full h-[400px] md:h-[500px] object-cover"
                  loading={index === 0 ? "eager" : "lazy"}
                  width={image.width || 1200}
                  height={image.height || 800}
                />
                
                {/* Compteur d'images */}
                <div className="absolute top-4 right-4">
                  <Badge variant="secondary" className="bg-black/60 text-white border-0">
                    {index + 1}/{images.length}
                  </Badge>
                </div>
                
                {/* Titre de l'image si disponible */}
                {image.caption && (
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                    <p className="text-white text-sm font-medium">
                      {image.caption}
                    </p>
                  </div>
                )}
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        
        {/* Boutons de navigation */}
        <CarouselPrevious className="left-4 bg-white/80 hover:bg-white border-0 shadow-lg" />
        <CarouselNext className="right-4 bg-white/80 hover:bg-white border-0 shadow-lg" />
      </Carousel>
      
      {/* Indicateurs de points (dots) */}
      {images.length > 1 && images.length <= 8 && (
        <div className="flex justify-center mt-4 space-x-2">
          {images.map((_, index) => (
            <div
              key={index}
              className="w-2 h-2 rounded-full bg-gray-300"
              // Note: Pour une vraie implémentation, vous pourriez ajouter la logique pour indiquer l'image active
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default PhotosCarousel;